import { render, staticRenderFns } from "./rwstep6.vue?vue&type=template&id=15d650ba&scoped=true&"
import script from "./rwstep6.vue?vue&type=script&lang=js&"
export * from "./rwstep6.vue?vue&type=script&lang=js&"
import style0 from "./rwstep6.vue?vue&type=style&index=0&id=15d650ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d650ba",
  null
  
)

export default component.exports